import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import './ProcessNodes.css';

/**
 * Categorical Chain Reasoner node (multi-pack mode).
 *
 * Renders the canvas card for the `chain_reasoner` execution type.
 * Shows the resolver and number of registry domains used as filters.
 */
function ChainReasonerNode({ data, selected }) {
  const inputCount = data.inputs?.length || 0;
  const outputCount = data.outputs?.length || 0;
  const cfg = data.chain_reasoner_config || {};
  const mode = cfg.mode || (cfg.pack_registry_path ? 'multi_pack' : 'single_pack');
  const resolver = cfg.resolver || 'snn_pipeline';
  const filters = Array.isArray(cfg.domain_filter) ? cfg.domain_filter : [];

  return (
    <div className={`process-node chain-reasoner-node ${selected ? 'selected' : ''}`}>
      <Handle type="target" position={Position.Left} className="node-handle input-handle" />

      <div className="node-header">
        <span className="node-icon">⛓️</span>
        <span className="node-type-badge chain-reasoner">CHAIN REASONER</span>
      </div>

      <div className="node-body">
        <div className="node-name">{data.name || 'Categorical Deep-Chain Reasoner'}</div>
        {data.description && (
          <div className="node-description">{data.description}</div>
        )}
        <div className="node-subline">
          mode: <strong>{mode}</strong> &middot; resolver: <strong>{resolver}</strong>
          {filters.length > 0 && (
            <> &middot; domains: <strong>{filters.join(', ')}</strong></>
          )}
        </div>
      </div>

      <div className="node-footer">
        <div className="node-meta">
          <span className="meta-item">
            <span className="meta-icon">↓</span>
            {inputCount} input{inputCount !== 1 ? 's' : ''}
          </span>
          <span className="meta-item">
            <span className="meta-icon">↑</span>
            {outputCount} output{outputCount !== 1 ? 's' : ''}
          </span>
        </div>
        <div className="node-model">{cfg.pack_registry_path ? 'registry' : 'single pack'}</div>
      </div>

      <Handle type="source" position={Position.Right} className="node-handle output-handle" />
    </div>
  );
}

export default memo(ChainReasonerNode);
